import httpClient from "@/plugins/axios";

export const getPolls = async (page = 1, pageSize = 100) => {
    const response = await httpClient.get(`/v1/polls/?page=${page}&page_size=${pageSize}`);
    return response;;
}

export const getPoll = async (id) => {
    const response = await httpClient.get(`/v1/polls/${id}/`);
    return response;
}

export const getUserPollAnswer = async (id) => {
    const response = await httpClient.get(`/v1/polls/${id}/answers/user/`);
    return response;
}

export const submitPollAnswer = async (id, answer) => {
    const response = await httpClient.post(`/v1/polls/${id}/answers/`, answer);
    return response;
}